export const CREATE_EXHIBITION_SUBCATEGORY = `
  mutation createExhibitionSubcategory($input: CreateExhibitionSubcategoryInput!, $tenant_id: Int!) {
    createExhibitionSubcategory(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
        name
        exhibition_category_id
        category {
          id
          name
        }
        tag
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_EXHIBITION_SUBCATEGORY = `
  mutation updateExhibitionSubcategory($input: UpdateExhibitionSubcategoryInput!, $tenant_id: Int!) {
    updateExhibitionSubcategory(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
        name
        exhibition_category_id
        category {
          id
          name
        }
        tag
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_EXHIBITION_SUBCATEGORY = `
  mutation deleteExhibitionSubcategory($id: Int!, $tenant_id: Int!) {
    deleteExhibitionSubcategory(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
